import { GALLERY, WHATSAPP_RESERVE_URL } from "../data/cafe";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="page-about" className="pt-32 pb-20">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <span className="text-xs uppercase tracking-[0.4em] text-[#FF8C5A]">
          About mismos
        </span>
        <h1 className="font-display text-5xl md:text-7xl mt-4 leading-[1.05]">
          A small room, a slow tempo,
          <span className="italic text-gradient"> a thousand stories.</span>
        </h1>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          <div className="md:col-span-2 aspect-[4/3] rounded-3xl overflow-hidden">
            <img src={GALLERY[0].url} alt="cafe" className="w-full h-full object-cover" />
          </div>
          <div className="aspect-[4/3] md:aspect-auto rounded-3xl overflow-hidden">
            <img src={GALLERY[2].url} alt="barista" className="w-full h-full object-cover" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mt-20">
          <div>
            <h2 className="font-display text-3xl mb-5">Where we began.</h2>
            <p className="text-white/70 leading-relaxed">
              mismos started as a quiet experiment — a corner table, a blender,
              and an obsession with getting the chill exactly right. From the
              first sip of Avil Milk to the last spoonful of falooda, every
              recipe was tasted, retasted and tuned until it earned its place
              on this menu.
            </p>
          </div>
          <div>
            <h2 className="font-display text-3xl mb-5">What we believe.</h2>
            <p className="text-white/70 leading-relaxed">
              Good drinks deserve unhurried evenings. Great food deserves great
              company. We keep the lights low, the music slow, and the doors
              open till late — because the best moments rarely keep a schedule.
            </p>
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-3 gap-6">
          {[
            { k: "150+", v: "Drinks & Bites" },
            { k: "14", v: "Categories Crafted" },
            { k: "Till late", v: "Open Every Day" },
          ].map((s) => (
            <div
              key={s.v}
              className="rounded-2xl border border-white/10 p-8 bg-[#0a0a0a]"
            >
              <div className="font-display text-5xl text-gradient">{s.k}</div>
              <div className="mt-2 text-xs uppercase tracking-[0.3em] text-white/60">
                {s.v}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <a
            href={WHATSAPP_RESERVE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="about-reserve-cta"
            className="inline-flex px-8 py-4 rounded-full bg-warm-gradient text-black font-medium hover:opacity-90 transition"
          >
            Reserve a Table
          </a>
        </div>
      </div>
    </div>
  );
}
